// Mapea una subscription al chip de estado mostrado en la tabla.
// Devuelve { label, color } donde color es válido para <Label color={...} />.
export function subscriptionStatus(sub) {
  if (!sub) return { label: 'Sin suscripción', color: 'default' };

  if (sub.status === 'active' && !sub.cancelAtPeriodEnd) {
    return { label: 'Activa', color: 'success' };
  }

  if (sub.status === 'active' && sub.cancelAtPeriodEnd) {
    const date = sub.currentPeriodEnd ? new Date(sub.currentPeriodEnd).toLocaleDateString() : '?';
    return { label: `Cancela ${date}`, color: 'warning' };
  }

  if (sub.status === 'unpaid') return { label: 'Impago', color: 'error' };
  if (sub.status === 'depleted') return { label: 'Agotada', color: 'warning' };
  if (sub.status === 'canceled') return { label: 'Cancelada', color: 'default' };
  if (sub.status === 'expired') return { label: 'Vencida', color: 'default' };

  // sub manual sin status marcado
  return { label: 'Sin estado', color: 'default' };
}

// `/subscriptions/list` parte el antiguo campo `user` en dos:
//   - holder:   de quién ES la sub (Subscription.userId, el titular)
//   - occupant: quién la USA (el user del seat)
// No coinciden siempre: en una huérfana hay holder sin occupant; en una de equipo (2+ ocupantes)
// los dos vienen null; y puede haber titular A con ocupante B.
// `user` sigue llegando como alias deprecado de `occupant` — lo leemos solo como fallback
// para no romper mientras el backend lo mantiene, pero desaparecerá.
export const subHolder = (sub) => sub?.holder ?? null;
export const subOccupant = (sub) => sub?.occupant ?? sub?.user ?? null;

export const stripeSubscriptionUrl = (stripeSubscriptionId) =>
  `https://dashboard.stripe.com/subscriptions/${stripeSubscriptionId}`;

// El `acct_*` queda hardcoded para forzar la cuenta correcta del dashboard cuando
// el admin está logueado en varias. Si en el futuro hay más cuentas, parametrizar.
export const stripeCustomerUrl = (stripeCustomerId) =>
  `https://dashboard.stripe.com/acct_1NEaOPDJADfWRuHz/customers/${stripeCustomerId}`;

export const SUB_STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'unpaid', label: 'Unpaid' },
  { value: 'depleted', label: 'Depleted' },
  { value: 'canceled', label: 'Canceled' },
  { value: 'expired', label: 'Expired' },
];

export const PLAN_STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'deprecated', label: 'Deprecated' },
  { value: 'archived', label: 'Archived' },
];
